import {obtenerCol} from "../../Servicios/BD/obtenerCol";

export const obtenerHabitaciones = async () => {

    let dox = await obtenerCol('habitaciones')

    return dox.data
}